import React from "react"
import './sidebar.css'
import img from '../../Assets/0.jpg'
import { Link } from "react-router-dom";
import { IoMdSpeedometer } from "react-icons/io"
import { MdDeliveryDining, MdOutlinePermContactCalendar } from "react-icons/md"
import { MdOutlineExplore } from "react-icons/md"
import { BsCreditCard2Front, BsQuestionCircle, BsTrophy } from "react-icons/bs"
import { AiOutlinePieChart } from "react-icons/ai"
import { BiTrendingUp } from "react-icons/bi"
import { useNavigate } from "react-router-dom";


const Sidebar = () =>{
  const navigate = useNavigate();

  return (
    <div className="sideBar grid">
      <div className="logoDiv flex">
        <img src={img} alt="Image Name"/>
        <h2 onClick={() => navigate('/admin')} className="cursor-pointer">
  Legalnable
</h2>

      </div>

      <div className="menuDiv">
        <h3 className="divTitle">
          QUICK MENU
        </h3>
        <ul className="menuLists grid">
        <li className="listItem">
          <Link to="/members" className="menuLink flex">
            <IoMdSpeedometer className="icon" />
            <span className="smallText">Members</span>
          </Link>
        </li>

        <li className="listItem">
          <Link to="/eventPage" className="menuLink flex">
            <MdDeliveryDining className="icon" />
            <span className="smallText">Events</span>
          </Link>
        </li>

        <li className="listItem">
          <Link to="/testimonials" className="menuLink flex">
            <MdOutlineExplore className="icon" />
            <span className="smallText">Testimonials</span>
          </Link>
        </li>

        <li className="listItem">
          <Link to="/blogs" className="menuLink flex">
            <BsTrophy className="icon" />
            <span className="smallText">Blogs</span>
          </Link>
        </li>
      </ul>
    </div>
    <div className="settingDiv">
      <h3 className="divTitle">
        SETTINGS
      </h3>
      <ul className="menuLists grid">
        <li className="listItem">
          <a href="#" className="menuLink flex">
            <AiOutlinePieChart className="icon"/>
            <span className="smallText">
              Charts
            </span>
          </a>
        </li>
        <li className="listItem">
          <a href="#" className="menuLink flex">
            <BiTrendingUp className="icon"/>
            <span className="smallText">
              Trends
            </span>
          </a>
        </li>
        <li className="listItem">
          <a href="#" className="menuLink flex">
            <MdOutlinePermContactCalendar className="icon"/>
            <span className="smallText">
              Contact
            </span>
          </a>
        </li>
        <li className="listItem">
          <a href="#" className="menuLink flex">
            <BsCreditCard2Front className="icon"/>
            <span className="smallText">
              Billing
            </span>
          </a>
        </li>
      </ul>
    </div>

    <div className="sideBarCard">
      <BsQuestionCircle className="sideBarIcon"/>
      <div className="cardContent">
        <div className="circle1"></div>
          <div className="circle1"></div>
          <h3> Help Center</h3>
          <p> Having trouble in Legalnable, please contact us from for more questions </p>
          <button className="sideBarBtn"> Go to help center</button>
      </div>

    </div>
    </div>
  )
}

export default Sidebar